<div
  *ngIf="type !== 'Typing'"
  class="message-container"
  [ngClass]="{ user: message.type === 'user', bot: message.type === 'bot' }"
>
  <img
    mat-card-avatar
    *ngIf="message.type === 'bot' && type !== 'Typing'"
    [src]="configs?.bot_profile_url"
    alt="Profile Image"
    class="profile-image"
  />

  <app-dynamic-text
    *ngIf="message.type === 'bot' && type === 'Text'"
    [input]="message.content"
    [isRead]="message.isRead"
  ></app-dynamic-text>

  <app-dynamic-buttons
    *ngIf="message.type === 'bot' && type === 'Buttons'"
    [ngStyle]="{ maxWidth: '302px', width: '100%' }"
    [input]="message.content"
    [lastMessage]="lastMessage"
    [isRead]="message.isRead"
    [canSendMessage]="canSendMessage"
    (action)="action.emit($event)"
  ></app-dynamic-buttons>
  <app-dynamic-pills
    *ngIf="message.type === 'bot' && type === 'Pills'"
    [ngStyle]="{ maxWidth: '302px', width: '100%' }"
    [input]="message.content"
    [lastMessage]="lastMessage"
    [isRead]="message.isRead"
    (action)="action.emit($event)"
  ></app-dynamic-pills>
  <app-dynamic-gallery
    *ngIf="message.type === 'bot' && type === 'Gallery'"
    [ngStyle]="{ width: '100%', overflow: 'hidden' }"
    [input]="message.content"
    (action)="action.emit($event)"
    [isRead]="message.isRead"
  ></app-dynamic-gallery>
  <app-dynamic-image
    *ngIf="message.type === 'bot' && type === 'Image'"
    [ngStyle]="{ width: '100%' }"
    [input]="message.content"
    [isRead]="message.isRead"
  ></app-dynamic-image>
  <app-dynamic-video
    *ngIf="message.type === 'bot' && type === 'Video'"
    [ngStyle]="{ width: '100%' }"
    [input]="message.content"
    [isRead]="message.isRead"
  ></app-dynamic-video>
  <app-dynamic-alert
    *ngIf="message.type === 'bot' && type === 'Alert'"
    [ngStyle]="{ width: '100%' }"
    [input]="message.content"
    [isRead]="message.isRead"
    [lastMessage]="lastMessage"
    (action)="action.emit($event)"
  ></app-dynamic-alert>

  <app-user-message
    *ngIf="
      message.type === 'user' &&
      (type === 'Text' || type === 'Attachments' || type === 'Button')
    "
    [input]="message.content"
  ></app-user-message>
</div>
<div class="message loading" *ngIf="message.type === 'loading'"></div>
<div *ngIf="type === 'Typing' && lastMessage" class="bot-typing-indicator">
  <mat-card
    class="typing-message"
    [ngStyle]="{
      'font-family': configs?.fonts?.bot_title_font,
      'font-size': configs?.fonts?.bot_title_font_size_px + 'px' || '20px',
      color: configs?.colors?.bot_title_text
    }"
  >
    <mat-card-content>
      <span class="animate-typing">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </span>
    </mat-card-content>
  </mat-card>
</div>
